import { rootApi } from "../../api/rootApi";

export const bchApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchBchDailyReport: builder.mutation({
            query: (params) => {
                return {
                    method: "POST",
                    url: `/tenant/bch/panel/daily-api-summary`,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                        slug: params.tenant_id,
                    },
                    body: params.body
                };
            },
        }),
    }),
});

export const {
    useFetchBchDailyReportMutation,
} = bchApi;
